import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { translationPropType } from '@eb/i18n';

import { Button } from '@eb/eds-button';
import { Icon } from '@eb/eds-icon';

import * as constants from './constants';

import { HeartChunky } from '@eb/eds-iconography';

export default class PhabButton extends PureComponent {
    static propTypes = {
        /**
         * Changes the style of the phab.
         * Available styles: neutral, fill
         */
        style: PropTypes.oneOf(constants.STYLES),
        /**
         * The type of icon that you want to display e.g. alert
         */
        iconType: constants.ICON_TYPES,
        /**
         * The title used to describe phab button
         */
        title: translationPropType,
        /**
         * Callback function invoked when the button is clicked.
         */
        onClick: PropTypes.func,
        /**
         * Prop specifying the size of the phab button
         */
        size: PropTypes.oneOf(constants.SIZES),
    };

    static defaultProps = {
        style: constants.STYLE_NEUTRAL,
        size: constants.SIZE_LARGE,
        iconType: <HeartChunky />,
    };

    render() {
        const { style, title, iconType, size, onClick } = this.props;

        const className = classNames(
            'eds-phab-button',
            `eds-phab-button--${size}`,
        );

        return (
            <div
                className={className}
                title={title}
                data-spec="eds-phab-button"
            >
                <Button style={style} phab={true} onClick={onClick}>
                    <Icon type={iconType} isBlockLevel={true} />
                </Button>
            </div>
        );
    }
}
